const youtubeplay = '#e83323'

// export const iconIncompleteColor = 'salmon'
export const iconIncompleteColor = '#56b4f8'
export const iconCompleteColor = "#7AC142"
export const todoCircleDiameter = 45
export const todoConnectorWidth = 5
export const iconActiveBackgroundColor = youtubeplay
